<template>
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16.79 15.11"
    >
        <path
            id="print_icon"
            data-name="print icon"
            class="cls-1"
            d="M14.27,4.2H2.52A2.51,2.51,0,0,0,0,6.71H0v5H3.36v3.35H13.43V11.75h3.36v-5A2.51,2.51,0,0,0,14.28,4.2Zm-2.52,9.24H5V9.24h6.72Zm2.52-5.88a.84.84,0,1,1,.84-.84.85.85,0,0,1-.84.84ZM13.43,0H3.36V3.36H13.43Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'PrintIcon'
}
</script>

<style lang="scss" scoped>
svg {
    width: 16.79px;
    height: 15.11px;
    margin: auto;
    path {
        fill: $white;
    }
}
svg:hover {
    path {
        fill: $blue;
    }
}
</style>